<template>
    <ApexCharts
        class="DonutChart"
        type="donut"
        :options="options"
        :series="series"
        :height="height"
        :width="width"
    />
</template>
<script>
import ApexCharts from 'vue-apexcharts';
import colors from 'style/_colors.scss';
import has from 'lodash/has';
import getRandomColor from '../getRandomColor';


const DataValidator = data => {
    return data.filter(d => {
        return has(d, 'label')
      && has(d, 'count');
    }).length === data.length;
};

export default {
    name: 'RPDonutChart',
    components: {
        ApexCharts,
    },
    props: {
        chartData: {
            type: Array,
            required: true,
            validator: DataValidator
        },
        showLegend: {
            type: Boolean,
            required: true
        },
        legendPosition: {
            type: String,
            default: 'bottom',
            validator: val => ['bottom', 'left', 'right'].indexOf(val) !== -1,
        },
        showTotal: {
            type: Boolean,
            default: true
        },
        totalLabel: {
            type: String,
            default: ''
        },
    },
    data(){
        return {
            height: '100%',
            width: '100%'
        };
    },
    computed: {
        series(){
            return this.chartData.map(s => s.count);
        },
        options(){
            return {
                dataLabels: {
                    enabled: false
                },
                chart: {
                    type: 'donut',
                    width: this.width
                },
                labels: this.chartData.map(s => s.label),
                colors: this.chartData.map(d => has(d, 'color') ? d.color : getRandomColor(JSON.stringify(d))),

                legend: {
                    show: this.showLegend,
                    position: this.legendPosition
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '90%',
                            labels: {
                                show: true,
                                total: {
                                    fontSize: '1.25rem',
                                    fontFamily: 'proxima-nova, sans-serif',
                                    fontColor: colors.textDark,
                                    showAlways: this.showTotal,
                                    show: this.showTotal,
                                    label: this.totalLabel
                                }
                            }
                        }
                    }
                },
            };
        }
    },
    mounted() {
        setTimeout(() => {
            this.height = '100%';
            this.width = '100%';
        }, 1);
    },
};
</script>
<style lang="scss">
    .DonutChart {
        padding: 0;
    }
</style>
